<template>
  <footer class="footer">
    <div class="container">
      <div class="copyright text-right">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://mountainbikeworldwide.com" target="_blank"
          >H+I Adventures</a
        >
        | <i class="fas fa-bicycle"></i> CRM v{{ appVersion }}
      </div>
    </div>
  </footer>
</template>
<script>
import { version } from "../../../../package.json";
export default {
  data() {
    return {
      appVersion: version
    };
  }
};
</script>
<style></style>
